import { CantonId, unCantonId } from './CantonId'

export interface Canton {
  cantonId: CantonId

  // The feature id inside the map. 1..26
  featureId: number

  // Weight of the canton for the purpose of counting 'Ständemehr'
  weight: 1 | 0.5
}

export const cantons: Array<Canton> = [
  { cantonId: 'ZH' as CantonId, featureId: 1, weight: 1 },
  { cantonId: 'BE' as CantonId, featureId: 2, weight: 1 },
  { cantonId: 'LU' as CantonId, featureId: 3, weight: 1 },
  { cantonId: 'UR' as CantonId, featureId: 4, weight: 1 },
  { cantonId: 'SZ' as CantonId, featureId: 5, weight: 1 },
  { cantonId: 'OW' as CantonId, featureId: 6, weight: 0.5 },
  { cantonId: 'NW' as CantonId, featureId: 7, weight: 0.5 },
  { cantonId: 'GL' as CantonId, featureId: 8, weight: 1 },
  { cantonId: 'ZG' as CantonId, featureId: 9, weight: 1 },
  { cantonId: 'FR' as CantonId, featureId: 10, weight: 1 },
  { cantonId: 'SO' as CantonId, featureId: 11, weight: 1 },
  { cantonId: 'BS' as CantonId, featureId: 12, weight: 0.5 },
  { cantonId: 'BL' as CantonId, featureId: 13, weight: 0.5 },
  { cantonId: 'SH' as CantonId, featureId: 14, weight: 1 },
  { cantonId: 'AR' as CantonId, featureId: 15, weight: 0.5 },
  { cantonId: 'AI' as CantonId, featureId: 16, weight: 0.5 },
  { cantonId: 'SG' as CantonId, featureId: 17, weight: 1 },
  { cantonId: 'GR' as CantonId, featureId: 18, weight: 1 },
  { cantonId: 'AG' as CantonId, featureId: 19, weight: 1 },
  { cantonId: 'TG' as CantonId, featureId: 20, weight: 1 },
  { cantonId: 'TI' as CantonId, featureId: 21, weight: 1 },
  { cantonId: 'VD' as CantonId, featureId: 22, weight: 1 },
  { cantonId: 'VS' as CantonId, featureId: 23, weight: 1 },
  { cantonId: 'NE' as CantonId, featureId: 24, weight: 1 },
  { cantonId: 'GE' as CantonId, featureId: 25, weight: 1 },
  { cantonId: 'JU' as CantonId, featureId: 26, weight: 1 },
]

export const lookupCanton = (id: CantonId): Canton => {
  const cd = cantons.find((x) => x.cantonId === unCantonId(id))
  if (cd === undefined) {
    console.warn(`lookupCanton: invalid CantonId ${id}`)
    return { cantonId: '<CantonId>' as CantonId, featureId: 0, weight: 1 }
  } else {
    return cd
  }
}

export const lookupCantonByFeatureId = (id: number): Canton => {
  const cd = cantons.find((x) => x.featureId === id)
  if (cd === undefined) {
    console.warn(`lookupCantonByFeatureId: invalid FeatureId ${id}`)
    return { cantonId: '<CantonId>' as CantonId, featureId: 0, weight: 1 }
  } else {
    return cd
  }
}

export const featureIdCode = (id: number): undefined | CantonId => {
  const cd = cantons.find((x) => x.featureId === id)
  return cd ? cd.cantonId : undefined
}
